import { px, pxToInt } from '@adsk/alloy-react-helpers';

import type { ADesignTokens, AlloyLegacyThemeDesignTokens } from '../types';
import type { Weave3ButtonInput } from '../types/weave3Types';
import type { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = WeaveTheme['tokens'];

export const getATokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): ADesignTokens => ({
  color: theme.tokens.colors.text.link.value,
  textDecoration: 'none',
  '&:hover': {
    color: theme.tokens.colors.text.hover.value,
    textDecoration: undefined,
    textDecorationThickness: undefined,
    textUnderlineOffset: undefined,
  },
  '&:active': {
    color: theme.tokens.colors.text.pressed.value,
  },
  '&:not(:hover):focus': {
    boxShadow: undefined,
    borderRadius: undefined,
  },
  '&:focus-visible': { outline: 'none' },
});

export const getATokensWeave = (tokens: WeaveTokens): ADesignTokens => {
  const textlink = tokens?.component?.textlink;
  const textColor = textlink?.primary?.['text-color'];

  return {
    color: textColor,
    textDecoration: 'none',
    '&:hover': {
      color: textColor,
      textDecoration: 'underline',
      textDecorationThickness: textlink?.['text-decoration-thickness']?.default,
      textUnderlineOffset: undefined,
    },
    '&:active': {
      color: textColor,
    },
    '&:not(:hover):focus': {
      boxShadow: textlink?.['box-shadow']?.focus,
      borderRadius: undefined,
    },
    '&:focus-visible': { outline: 'none' },
  };
};

export const getATokensWeave3 = (button?: Weave3ButtonInput): ADesignTokens => {
  const link = button?.link;
  const textColor = link?.['text-color'];
  const thickness = link?.['text-decoration']?.thickness?.default;
  const shadowColor = button?.['box-shadow-color']?.focus;
  const shadowSpread = button?.['box-shadow-spread']?.focus;

  return {
    color: textColor?.default,
    textDecoration: 'none',
    '&:hover': {
      color: textColor?.hover,
      textDecoration: 'underline',
      textDecorationThickness: thickness ? px(pxToInt(thickness)) : undefined,
      textUnderlineOffset: link?.['text-decoration']?.offset,
    },
    '&:active': {
      color: textColor?.default,
    },
    '&:not(:hover):focus': {
      boxShadow: shadowColor
        ? `0 0 0 ${shadowSpread ?? '0px'} ${shadowColor}`
        : undefined,
      borderRadius: link?.['border-radius']?.focus,
    },
    '&:focus-visible': { outline: 'none' },
  };
};
